import configData from "./config.json";
import { resolveAppEnv } from "./resolveAppEnv.js";

const QURAN_PAGES_BASE_URL =
  "https://hafizmuhammadaslam10.github.io/rabbani-school-assets/quran/";
const QUAIDA_PAGES_BASE_URL =
  "https://hafizmuhammadaslam10.github.io/rabbani-school-assets/qauida/";

const modeKey = resolveAppEnv(import.meta.env.MODE);
const envConfig = configData[modeKey] || configData.local;

export const baseUrl = envConfig.API_BASE_URL;
export const s3baseUrl = envConfig.S3_BASE_URL;
export const clientBaseUrl = envConfig.CLIENT_BASE_URL;
export const quranPagesBaseUrl = QURAN_PAGES_BASE_URL;
export const quaidaPagesBaseUrl = QUAIDA_PAGES_BASE_URL;
export const projectMode = envConfig.PROJECT_MODE;

export const xsAuthClientId = envConfig.XS_AUTH_CLIENT_ID;
export const xsAuthUrl = envConfig.XS_AUTH_URL;
export const xsAuthBootstrapUrl = envConfig.XS_AUTH_BOOTSTRAP_URL;
export const xsAccountUrl = envConfig.XS_ACCOUNT_URL;

export const xsAuthProxyTarget = envConfig.XS_AUTH_PROXY_TARGET;
export const apiProxyTarget = envConfig.API_PROXY_TARGET;
export const devServerPort = envConfig.DEV_SERVER_PORT;
export const enableDevLogger = envConfig.ENABLE_DEV_LOGGER !== false;

export const peerHost = envConfig.PEER_HOST;
export const peerPort = envConfig.PEER_PORT;
export const peerPath = envConfig.PEER_PATH;
export const peerSecure = envConfig.PEER_SECURE;
export const peerKey = envConfig.PEER_KEY;
export const peerEnabled = envConfig.PEER_ENABLED !== false;
export const turnIceUrls = envConfig.TURN_ICE_URLS;
